import { SourcesListComponent } from "./pages/candidate-sources-list/sources-list.component";
import { AuthGuard } from "../../../auth/helpers";
import { CandidateListComponent } from "./pages/candidate-list/candidate-list.component";
import { CandidateFormComponent } from "./pages/candidate-form/candidate-form.component";
import { HiredCandidatesListComponent } from "./pages/hired-candidates-list/hired-candidates-list.component";
import { SuitablesCandidateListComponent } from "./pages/suitables-candidate-list/suitables-candidate-list.component";
import { IRoute } from "app/auth/models/utils-interfaces";
import { CandidateRatingsListComponent } from "./pages/candidate-ratings-list/candidate-ratings-list.component";

const candidatesRoutes: IRoute[] = [
  {
    path: "dashboard/candidate-source",
    component: SourcesListComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "dashboard/candidate/list",
    component: CandidateListComponent,
    canActivate: [AuthGuard],
    capability: "view_candidate_list",
  },
  {
    path: "dashboard/candidate/add",
    component: CandidateFormComponent,
    canActivate: [AuthGuard],
    capability: "add_candidate",
  },
  {
    path: "dashboard/candidate/edit/:user_identifier",
    component: CandidateFormComponent,
    canActivate: [AuthGuard],
    capability: "edit_candidate",
  },
  {
    path: "dashboard/hired-candidates/list",
    component: HiredCandidatesListComponent,
    canActivate: [AuthGuard],
    capability: "show_hired_candidate_list",
  },
  // lista candidati idonei
  {
    path: "dashboard/requests-eligible-candidate-list",
    component: SuitablesCandidateListComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "dashboard/candidate-ratings",
    component: CandidateRatingsListComponent,
    canActivate: [AuthGuard],
  },
];
export default candidatesRoutes;
